import { Route, Routes, Navigate } from "react-router-dom";

import { PageError } from "components/layout";
import { ExtendedRoute } from "containers/ExtendedRoute";
import { RedirectById } from "containers/Layout/SideMenu/redirect/RedirectById";
import { RedirectDependingOnRoles } from "containers/Layout/SideMenu/redirect/RedirectDependingOnRoles";
import { RestrictedArea, ALL_TIVO } from "containers/Permissions";
import { trans } from "src/translations";

import { TiVoAppDetails } from "./AppDetails/TiVoAppDetails";
import { TiVoProviderForm } from "./AppForm/TiVoProviderForm";
import { TiVoVariantForm } from "./AppForm/TiVoVariantForm";
import { TiVoAppsList } from "./AppsList/TiVoAppsList";
import { DEFAULT_PATHS, MAIN_ROUTE } from "./constants";
import { TiVoPublicationsList } from "./PublicationsList";
import { PATHS as PUBLICATION_LIST_PATHS } from "./PublicationsList/constants";
import { TiVoPublicationsRedirect } from "./PublicationsList/TiVoPublicationsRedirect";
import { Schedules } from "./Schedules/Schedules";

export function TiVoAppsRoute() {
  return (
    <RestrictedArea
      allowed={ALL_TIVO}
      fallbackChildren={
        <PageError pageHeader={null} error={{ isForbidden: true }} />
      }
    >
      <Routes>
        <Route index element={<RedirectDependingOnRoles />} />
        <Route
          path="/list"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_LIST_ROUTE_NAME()}
              component={TiVoAppsList}
            />
          }
        />
        <Route
          path="/create"
          element={
            <Navigate to={`/${MAIN_ROUTE}/create/${DEFAULT_PATHS.APP_FORM}`} />
          }
        />
        <Route
          path="/create/*"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_CREATE_ROUTE_NAME()}
              component={TiVoProviderForm}
            />
          }
        />
        <Route
          path="/create/:id/variant"
          element={
            <RedirectById
              idParams={["id"]}
              path={`/${MAIN_ROUTE}/create/:id/variant/${DEFAULT_PATHS.VARIANT_FORM}`}
            />
          }
        />
        <Route
          path="/create/:id/variant/*"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_VARIANT_CREATE_ROUTE_NAME()}
              component={TiVoVariantForm}
            />
          }
        />
        <Route
          path="/edit/:id/*"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_EDIT_ROUTE_NAME()}
              component={TiVoProviderForm}
            />
          }
        />
        <Route
          path="/edit/:id/variant/:variantId"
          element={
            <RedirectById
              idParams={["id", "variantId"]}
              path={`/${MAIN_ROUTE}/edit/:id/variant/:variantId/versions/latest`}
            />
          }
        />
        <Route
          path="/edit/:id/variant/:variantId/versions/:versionId"
          element={
            <RedirectById
              idParams={["id", "variantId", "versionId"]}
              path={`/${MAIN_ROUTE}/edit/:id/variant/:variantId/versions/:versionId/${DEFAULT_PATHS.VARIANT_FORM}`}
            />
          }
        />
        <Route
          path="/edit/:id/variant/:variantId/versions/:versionId/*"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_VARIANT_EDIT_ROUTE_NAME()}
              component={TiVoVariantForm}
            />
          }
        />
        <Route
          path="/details/:id"
          element={
            <RedirectById
              idParams={["id"]}
              path={`/${MAIN_ROUTE}/details/:id/${DEFAULT_PATHS.APP_DETAILS}`}
            />
          }
        />
        <Route
          path="/details/:id/*"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_DETAILS_ROUTE_NAME()}
              component={TiVoAppDetails}
            />
          }
        />
        <Route
          path="/details/:id/variant/:variantId"
          element={
            <RedirectById
              idParams={["id", "variantId"]}
              path={`/${MAIN_ROUTE}/details/:id/variant/:variantId/${DEFAULT_PATHS.VARIANT_DETAILS}`}
            />
          }
        />
        <Route
          path="/details/:id/variant/:variantId/*"
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_VARIANT_DETAILS_ROUTE_NAME()}
              component={TiVoAppDetails}
            />
          }
        />
        <Route
          path="/publication"
          element={
            <Navigate
              to={`/${MAIN_ROUTE}/publication/${PUBLICATION_LIST_PATHS.SUMMARY}`}
            />
          }
        />
        <Route
          path={`/publication/${PUBLICATION_LIST_PATHS.SUMMARY}`}
          element={<TiVoPublicationsRedirect />}
        />
        <Route
          path={`/publication/${PUBLICATION_LIST_PATHS.SUMMARY}/:tabId`}
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_PUBLICATION_SUMMARY_ROUTE_NAME()}
              component={TiVoPublicationsList}
            />
          }
        />
        <Route
          path={`/publication/${PUBLICATION_LIST_PATHS.EDIT}`}
          element={<TiVoPublicationsRedirect />}
        />
        <Route
          path={`/publication/${PUBLICATION_LIST_PATHS.EDIT}/:tabId`}
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_PUBLICATION_EDIT_ROUTE_NAME()}
              component={TiVoPublicationsList}
            />
          }
        />
        <Route
          path={`/publication/${PUBLICATION_LIST_PATHS.HISTORY}`}
          element={<TiVoPublicationsRedirect />}
        />
        <Route
          path={`/publication/${PUBLICATION_LIST_PATHS.HISTORY}/:tabId`}
          element={
            <ExtendedRoute
              name={trans.TIVO_APPS_PUBLICATION_HISTORY_ROUTE_NAME()}
              component={TiVoPublicationsList}
            />
          }
        />
        <Route path="/schedules" element={<Schedules />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </RestrictedArea>
  );
}
